var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmail = function SvgEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    d: "M17.5 10a7.5 7.5 0 1 0-5.559 7.244"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 3.333,
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ADADAD",
    strokeLinecap: "round",
    strokeWidth: 1.25,
    d: "M13.333 7.5v3.75a2.083 2.083 0 1 0 4.167 0V10"
  })));
};
export default SvgEmail;